import { render, staticRenderFns } from "./Side_bar.vue?vue&type=template&id=0db1d1b0"
import script from "./Side_bar.vue?vue&type=script&lang=js"
export * from "./Side_bar.vue?vue&type=script&lang=js"
import style0 from "./Side_bar.vue?vue&type=style&index=0&id=0db1d1b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports